import { gql } from '__generated__';

export default gql(`
  mutation DeleteNote($id: ID!) {
    deleteNote(id: $id)
  }
`);
